import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "../data/site";
import { Reveal } from "./Reveal";
import { useI18n } from "../i18n/LanguageContext";

export const Manifesto = () => {
  const { t } = useI18n();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  const chapters = t("manifesto.chapters");

  return (
    <section ref={ref} data-testid="manifesto-section" className="relative py-28 md:py-40 overflow-hidden">
      <motion.div style={{ y }} className="absolute inset-0 -top-[15%] -bottom-[15%]">
        <img src={IMAGES.manifesto} alt="" aria-hidden className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-pine-dark/85" />
      </motion.div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-wood font-semibold">{t("manifesto.overline")}</p>
        </Reveal>

        <div className="mt-16 space-y-20 md:space-y-28">
          {chapters.map((c, i) => (
            <Reveal key={c.title} delay={0.1}>
              <div className="grid md:grid-cols-12 gap-6 items-start">
                <span className={`font-serif text-7xl md:text-8xl text-outline leading-none md:col-span-3 ${i % 2 === 1 ? "md:order-2 md:text-right" : ""}`}>
                  0{i + 1}.
                </span>
                <div className={`md:col-span-6 ${i % 2 === 1 ? "md:order-1" : "md:col-start-5"}`}>
                  <h3 className="font-serif text-3xl md:text-5xl text-cream tracking-tight italic">{c.title}</h3>
                  <p className="mt-6 text-cream/70 leading-relaxed text-base md:text-lg max-w-xl">{c.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
